import { ProfileGroup } from '@/features/Auth/machine/completion'

/**
 * Where each group of missing details is asked for.
 *
 * The mapping lives here, not in the completeness check. `checkSignupCompletion` used to
 * return the destination alongside the answer, which put a navigation decision inside a data
 * question and meant the flow could only be followed by performing it — the same reason the
 * machine reports states and the bridge decides what they mean.
 *
 * Personal and work details are two separate steps because the product says so: the rule is
 * in the Notion "Kite Business Rules" database that `docs/PROJECT.md` cites, not here. A
 * mapping that folded two groups into one screen would change what the product asks and
 * when. See EPIC-005.
 */
export type CompletionStep = 'signup' | 'aboutYou' | 'aboutJob'

export const ASKED_IN: Record<ProfileGroup, CompletionStep> = {
  signup: 'signup',
  personal: 'aboutYou',
  work: 'aboutJob'
}

/** The first step that still has something to ask, or null when nothing is missing. */
export function nextCompletionStep(missing: ProfileGroup[]): CompletionStep | null {
  return missing.length > 0 ? ASKED_IN[missing[0]] : null
}
